import React, { ReactNode } from 'react';
import styles from './index.less';

type ServiceGuidelinesProps = {
  children?: ReactNode;
}

const ServiceGuidelines = (props: ServiceGuidelinesProps) => {
  return (
    <p className={styles.paragraph}>
      { props.children }
    </p>
  );
};

export default ServiceGuidelines;
